module.exports = __webpack_public_path__ + "static/media/model_X.46f0aa6c.png";